import React from 'react';
import { withCookies } from 'react-cookie';

import { Button, } from 'antd';
import { Toast } from 'antd-mobile';

import "./index.css";
import styles from "./form.module.css";
import { SelectMember } from '../MyModals';
import { _loginByUserid } from "../../server";

class MorePage extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            selectedData: [],
            selectedExtra: {},
        }
        const { cookies } = this.props;
        this.sid = cookies.get(process.env.TOKEN_KEY);
    }

    bindRef = ref => {
        this.selectMemberModal = ref
    }

    async loginByUserid(userid) {
        if (!userid) {
            return;
        }
        const res = await _loginByUserid(this.sid, userid);
        if (res.code === 0) {
            this.setToken(res.data.sid);
            Toast.info('切换成功', 1);
            this.props.callback();
        } else {
            Toast.info('切换失败，请重试', 1);
        }
    }

    setToken(token) {
        const { cookies } = this.props;
        cookies.set(process.env.TOKEN_KEY, token, { path: '/' });
    }

    updateSelectedData = (extra, list) => {
        switch (extra.type) {
            case 1:
                //切换身份
                this.setState({ selectedData: list });
                if (list) {
                    this.loginByUserid(list[0].userid);
                }
                break;
            default:
                // code...
                break;
        }
    }

    render() {
        return <div style={{ backgroundColor: 'white', textAlign: 'center', padding: 30 }}>
            {
                /**
                 * <div className="empty"><div className="img"></div><p className="desc">暂无数据</p></div>
                 */
            }
            {
                this.state.selectedData.length > 0 ?
                    this.state.selectedData.map((item, index) =>
                        <div key={index} className={styles.userContentWrap}>
                            <div className={styles.userSelectView}>
                                <p className={styles.img}><img className={styles.user_select_img} src={item.avatar}></img></p>
                                <p className={styles.userInfo_name}>{item.name}</p>
                            </div>
                        </div>
                    )
                    : ""
            }
            <div>
                {
                    // <div className="addForm"
                    //     onClick={(e) => {
                    //         e.preventDefault();
                    //         this.setState({ selectedData: this.state.selectedData, selectedExtra: { type: 1, maxLength: 1 } }, () => setTimeout(this.selectMemberModal.showModal(), 20));
                    //     }}>切换用户身份</div>
                }
            </div>
            <SelectMember triggerRef={this.bindRef} callback={this.updateSelectedData} selectedData={this.state.selectedData} sid={this.sid} extra={this.state.selectedExtra} />
        </div>;
    }

}

export default withCookies(MorePage);